import PropTypes from "prop-types";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import Paragraphs from "app/pages/.shared/Paragraphs";
import LineClampViewMore from "app/pages/.shared/LineClampViewMore/LineClampViewMore";
import "app/pages/.shared/PartnerSEO/PartnerSEO.scss";

const PartnerSEO = ({ title = [], description = [], resolution }) => {
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	if (title.length === 0 && description.length === 0) {
		return <></>;
	}

	return (
		<div className="partner-seo" data-testid="partner-seo">
			<div className="partner-seo__container">
				<h3>
					<Paragraphs paragraphs={title} enableHTMLFormatting={true} />
				</h3>
				<LineClampViewMore
					enableShowMore={true}
					lineCount={isMobile ? 6 : 3}
					text={<Paragraphs paragraphs={description} enableHTMLFormatting={true} />}
				/>
			</div>
		</div>
	);
};

PartnerSEO.propTypes = {
	title: PropTypes.arrayOf(PropTypes.string),
	description: PropTypes.arrayOf(PropTypes.string),
	resolution: PropTypes.string,
};

export default PartnerSEO;
